module.exports = __webpack_public_path__ + "img/sthree.9dd90160.png";